const i = (o) => ({
  [o.componentCls]: {
    // For common/openAnimation
    [`${o.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${o.motionDurationMid} ${o.motionEaseInOut},
        opacity ${o.motionDurationMid} ${o.motionEaseInOut} !important`
      }
    },
    [`${o.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${o.motionDurationMid} ${o.motionEaseInOut},
        opacity ${o.motionDurationMid} ${o.motionEaseInOut} !important`
    }
  }
}), t = i;
export {
  t as g
};
//# sourceMappingURL=collapse-Dt2ZKH64.mjs.map
